module.exports = __webpack_public_path__ + "img/burn-mango.ad2ee34b.png";